<template>
  <div>
    <NuxtLoadingIndicator
      :color="COLOR_PRIMARY"
      :error-color="COLOR_DANGER"
    />

    <NuxtLayout>
      <NuxtPage :keepalive="{ include: CACHED_PAGES, max: 1 }" />
    </NuxtLayout>

    <div
      class="fixed left-0 bottom-0 bg-warning text-white px-1 rounded-sm text-xxs"
      style="z-index: 999"
      v-if="is_dev"
    >
      <span class="hidden sm:inline-block">آزمایشی</span>
    </div>

    <div
      ref="refFloats"
      class="c-floats space-y-2"
      id="floats"
    ></div>

    <!--      <base-modal-->
    <!--        size="xs"-->
    <!--        :shown="isAppUpdated"-->
    <!--        :closeable="false"-->
    <!--        v-if="isAppUpdated"-->
    <!--      >-->
    <!--        <div class="flex flex-col items-center text-center">-->
    <!--          <base-loading/>-->

    <!--          <p>نسخه جدیدی در دسترس است</p>-->

    <!--          <p>در حال بروزرسانی...</p>-->
    <!--        </div>-->
    <!--      </base-modal>-->
  </div>
</template>

<script setup>
import '~/assets/js/functions/validator/validator';
import is_dev_function from '~/assets/js/functions/is_dev';
// import useWorkbox from "~/assets/js/composables/other/useWorkbox.js";
import { SimpleStorage } from './assets/js/classes/Storage';
import { KEY_CREATION_TAG } from './assets/js/consts/storageKeys.const';
import { init_clarity } from '~/assets/js/plugins/clarity';
import { COLOR_DANGER, COLOR_PRIMARY } from '~/assets/js/consts/colors.consts';
import usePageScroll from '~/assets/js/composables/other/usePageScroll';

const route = useRoute();

const CACHED_PAGES = [
  'store.category',
  'store.category.single',
  'warehouse.category',
  'warehouse.category.single',
];
const refFloats = ref();

const is_dev = is_dev_function();

// const { isAppUpdated, offlineReady, update, close } = useWorkbox();

if (import.meta.client && !is_dev) {
  init_clarity();
}

if (process.client) {
  usePageScroll(refFloats, 'c-floats');
}

onMounted(() => {
  const utms = SimpleStorage.getItem(KEY_CREATION_TAG) || {};

  if (!utms.landing_url) {
    utms.landing_url = window.location.origin + route.path;
  }

  if (route.query.utm_source && route.query.utm_medium) {
    Object.assign(utms, route.query);
  }

  SimpleStorage.setItem(KEY_CREATION_TAG, utms);
});
</script>

<style>
.page-enter-active,
.page-leave-active,
.layout-enter-active,
.layout-leave-active {
  transition: opacity 300ms ease-in-out;
}

.page-enter-from,
.page-leave-to,
.layout-enter-from,
.layout-leave-to {
  opacity: 0;
}

.anim-floats-move,
.anim-floats-enter-active,
.anim-floats-leave-active {
  transition: all 0.5s ease;
  will-change: opacity, transform;
}

.anim-floats-enter-from,
.anim-floats-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.anim-floats-leave-active {
  position: absolute;
}
</style>
